<template>
    <b-modal :ref="modalRef" hide-footer :title="modalTitle" :id="modalId">
        <ValidationObserver ref="splitCellObserver" tag="form">
            <div class="row w-100 mb-2">
                <div class="col">
                    <CCAMultiSelect 
                        required
                        refName="cellToSplit"
                        input-label="Nom de la cellule"
                        v-model="selectedCellOption"
                        placeholder="Sélectionner une cellule"
                        :options="cellOptions"
                        optionLabel="label" 
                        trackByField="value"
                    />
                </div>
            </div>

            <div class="row w-100">
                <div class="col">
                    <CCAMultiSelect
                        required
                        ref-name="numberOfCells"
                        input-label="Nombre de sous cellules"
                        v-model="selectedNumberOfCells"
                        placeholder="Sélectionner un nombre"
                        :options="numberOfCells"
                        optionLabel="label"
                        :preselect-first="true"
                        :show-labels="false" 
                        :allow-empty="false" 
                        :track-by-field="'value'"
                    />
                </div>
            </div>

            <div class="row w-100 mt-2">
                <div class="col">
                    <label for="disposition">Disposition</label>
                    <b-form-radio-group
                        v-model="selectedDisposition"
                        :options="dispositionOptions"
                        value-field="item"
                        text-field="name"
                        disabled-field="notEnabled"
                        class="mt-1"
                    />
                </div>
            </div>

            <div class="row justify-content-end w-100">
                <div class="col-auto">
                    <button type="button" class="btn btn-secondary-light-o btn-radius mr-2" @click="$bvModal.hide(modalId)">Annuler</button>
                    <button @click="applyCellSplit" type="button" class="btn btn-primary btn-radius">Appliquer</button>
                </div>
            </div>
        </ValidationObserver>
    </b-modal>
</template>
  
<script>
import { ValidationObserver } from 'vee-validate';
import CCAMultiSelect from '@/components/inputs/CCAMultiSelect';

export default {
    props: {
        modalRef: {
            type: String,
            default: 'subdivideCellModal',
        },
        modalTitle: {
            type: String,
            default: `Subdiviser une cellule de la ligne`,
        },
        modalId: {
            type: String,
            default: 'subdivide-cell-modal',
        },
        selectedLine: {
            type: Number,
            default: 1,
        },
        cellOptions: {
            type: Array,
            default: () => [],
        }
    },
    components: {
        ValidationObserver,
        CCAMultiSelect,
    },
    data() {
        return {
            selectedCellOption: { label: "Cellule 02", value: 1 },
            selectedNumberOfCells: { label: "2", value: 2 },
            numberOfCells: [
                { label: "1 (Réinitialiser)", value: 1 },
                { label: "2", value: 2 },
                { label: "3", value: 3 },
                { label: "4", value: 4 },
            ],
            selectedDisposition: "horizontal",
            dispositionOptions: [
                { item: "horizontal", name: "Colonnes" },
                { item: "vertical", name: "Lignes" },
            ],
        };
    },
    methods: {
        async applyCellSplit() {
            const isValid = await this.$refs.splitCellObserver.validate();

            if (isValid) {
                this.$emit("appliedCellSplit", {
                    numberOfCells: this.selectedNumberOfCells.value,
                    disposition: this.selectedDisposition,
                    selectedCellIndex: this.selectedCellOption.value
                })
            }
        },
    },
}
</script>
  